// /admin/shows — shows management in the admin AppShell (production zone, video
// surface; parity with /creator/shows). Shared component so the studio hub's
// "Manage shows" link stays within the admin chrome instead of flipping to the
// creator chrome. See features/live/ShowsManager.
import { createFileRoute } from '@tanstack/react-router';

import { ShowsManager } from '@/features/live/ShowsManager';

export const Route = createFileRoute('/admin/shows')({
  component: ShowsManager,
});
